// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2OBNh","row":"ProcedureTreatmentSummary_row__2AJ4y"};